import { defineMessages } from 'react-intl';

/**
 * react-intl messages for the React `widget` macro renderer. Mirrors keys from
 * the legacy `confluence-widget-connector` plugin's `i18n.properties` so that
 * existing translations remain reusable.
 */
export const i18n: {
	urlNotSpecified: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	myspaceOutdated: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	flashDeprecated: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unsupportedProvider: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	macroLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	macroDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	embedTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	twitterWidgetHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	twitterWidgetMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	twitterWidgetLink: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	twitterSingleError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	urlNotSpecified: {
		id: 'widget-macro.error.url-not-specified',
		defaultMessage: 'No URL specified.',
		description: 'Error shown when the widget macro is rendered without a `url` parameter or body.',
	},
	myspaceOutdated: {
		id: 'widget-macro.error.myspace-outdated',
		defaultMessage: 'This myspace URL is outdated, please update.',
		description:
			'Error shown when a user supplies a deprecated `vids.myspace.com` URL to the widget macro.',
	},
	flashDeprecated: {
		id: 'widget-macro.error.flash-deprecated',
		defaultMessage:
			'This widget cannot be displayed because it requires Adobe Flash, which is no longer supported by modern browsers.',
		description:
			'Error shown for providers (DailyMotion, Flickr) whose embed used Flash and can no longer be rendered.',
	},
	unsupportedProvider: {
		id: 'widget-macro.error.unsupported-provider',
		defaultMessage: 'The widget at {url} cannot be embedded.',
		description:
			'Error shown when no provider matches the supplied URL. {url} is the host of the URL the user supplied.',
	},
	macroLabel: {
		id: 'widget-macro.label',
		defaultMessage: 'Widget Connector',
		description: 'Display label for the widget macro.',
	},
	macroDescription: {
		id: 'widget-macro.desc',
		defaultMessage:
			'Embed YouTube videos, Flickr slideshows, Twitter streams, Google Docs and other content from the web.',
		description: 'Description of the widget macro shown in the macro browser.',
	},
	embedTitle: {
		id: 'widget-macro.embed-title',
		defaultMessage: 'Embedded {provider} content',
		description:
			'Accessible title applied to the embedded iframe. {provider} is the provider name (e.g. YouTube).',
	},
	twitterWidgetHeading: {
		id: 'widget-macro.twitter.widget.heading',
		defaultMessage: 'Loading Twitter Widget',
		description: 'Heading shown while a Twitter timeline widget is loading.',
	},
	twitterWidgetMessage: {
		id: 'widget-macro.twitter.widget.message',
		defaultMessage: 'Widget #{widgetId}',
		description:
			'Body text shown while a Twitter timeline widget is loading. {widgetId} is the numeric widget ID.',
	},
	twitterWidgetLink: {
		id: 'widget-macro.twitter.widget.link',
		defaultMessage: 'Loading Widget #{widgetId}',
		description:
			'Accessible link text for a loading Twitter widget. {widgetId} is the numeric widget ID.',
	},
	twitterSingleError: {
		id: 'widget-macro.twitter.single.error',
		defaultMessage: 'Error rendering Tweet {tweetId}\u2026',
		description:
			'Error message shown when a single tweet fails to render. {tweetId} is the numeric tweet ID.',
	},
});
